module.exports = __webpack_public_path__ + "img/12 Vudim.d7111d34.png";